import React from 'react';
import { cn } from 'src/lib/utils';
import {
  STATUS_PILL_BASE,
  STATUS_SCHEMES,
  DEFAULT_STATUS_SCHEME,
} from 'src/lib/statusStyles';

// Each status maps to a color scheme; styling/dark-mode lives in statusStyles.
const STATUS_CONFIG = {
  // Green — active / positive outcomes
  ACTIVE: { label: 'Active', scheme: 'emerald' },
  APPROVED: { label: 'Approved', scheme: 'emerald' },
  COMPLETED: { label: 'Completed', scheme: 'emerald' },
  PROCESSED: { label: 'Processed', scheme: 'emerald' },
  APPLIED: { label: 'Applied', scheme: 'emerald' },
  OPEN: { label: 'Open', scheme: 'emerald' },
  PASSED: { label: 'Passed', scheme: 'emerald' },

  // Teal — payment received
  PAID: { label: 'Paid', scheme: 'teal' },
  PARTIALLY_PAID: { label: 'Partially Paid', scheme: 'teal' },

  // Red — inactive / errors
  INACTIVE: { label: 'Inactive', scheme: 'red' },
  CANCELED: { label: 'Canceled', scheme: 'red' },
  CANCELLED: { label: 'Canceled', scheme: 'red' },
  REJECTED: { label: 'Rejected', scheme: 'red' },
  OVERDUE: { label: 'Overdue', scheme: 'red' },
  CLOSED: { label: 'Closed', scheme: 'red' },
  FAILED: { label: 'Failed', scheme: 'red' },

  // Amber — pending / awaiting action
  PENDING: { label: 'Pending', scheme: 'amber' },
  PENDING_APPROVAL: { label: 'Pending Approval', scheme: 'amber' },
  PAYMENT_AWAITED: { label: 'Payment Awaited', scheme: 'amber' },
  ON_HOLD: { label: 'On Hold', scheme: 'amber' },

  // Indigo — sent / generated / issued
  SENT: { label: 'Sent', scheme: 'indigo' },
  ISSUED: { label: 'Issued', scheme: 'indigo' },
  GENERATED: { label: 'Generated', scheme: 'indigo' },

  // Violet — revised / modified
  REVISED: { label: 'Revised', scheme: 'violet' },
  MODIFIED: { label: 'Modified', scheme: 'violet' },

  // Gray — draft / neutral
  DRAFT: { label: 'Draft', scheme: 'gray' },
  NOT_STARTED: { label: 'Not Started', scheme: 'gray' },
};

export function StatusBadge({ value, label: labelProp }) {
  const cfg = STATUS_CONFIG[value];
  const label = labelProp ?? cfg?.label ?? value;
  const scheme = STATUS_SCHEMES[cfg?.scheme ?? DEFAULT_STATUS_SCHEME];

  return (
    <span className={cn(STATUS_PILL_BASE, scheme.pill)}>
      <span
        className={cn('h-1.5 w-1.5 rounded-full shrink-0', scheme.dot)}
        aria-hidden
      />
      {label}
    </span>
  );
}
